import React from 'react';
import { useTranslate } from 'react-admin';
import { Skeleton } from '@material-ui/lab';
import Drawer from '~/components/Drawer';
import { useChangelog } from '~/hooks/useChangelogContext';
import { Changelog as ChangelogType } from '~/types/Changelog';
import ChangelogEntry from './ChangelogEntry';

const ChangelogDrawer = () => {
  const {
    isAvailable,
    isDrawerOpen,
    closeDrawer,
    changelogs,
    isLoadingChangelogs,
  } = useChangelog();

  const translate = useTranslate();
  const t = (key: string): string => translate(`components.Changelog.${key}`);

  if (!isAvailable) {
    return null;
  }

  return (
    <Drawer heading={t('heading')} open={isDrawerOpen} onClose={closeDrawer}>
      {isLoadingChangelogs && <Skeleton width='100%' height='50px' />}
      {!isLoadingChangelogs &&
        changelogs.map((changelog: ChangelogType) => (
          <ChangelogEntry key={changelog.id} changelog={changelog} />
        ))}
    </Drawer>
  );
};

export default ChangelogDrawer;
